import { render } from "./write.vue?vue&type=template&id=7f9130ac"
import script from "./write.vue?vue&type=script&lang=js"
export * from "./write.vue?vue&type=script&lang=js"

import "./write.vue?vue&type=style&index=0&id=7f9130ac&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__